export const MainChainInfo = {
  chainId: 'AELF',
  endPoint: 'https://explorer.aelf.io/chain',
  // TODO
  contractAddress: '',
  name: 'MainChain AELF',
  exploreUrl: 'https://explorer.aelf.io/',
};

export const MAIN_CHAIN_ID = 'AELF';
export const MAIN_CHAIN = 'MainChain';
export const SIDE_CHAIN = 'dAppChain';
export const MAINNET = 'MAINNET';
export const TESTNET = 'TESTNET';
export const TEST_NET = 'Testnet';
